"use client";

import { styled, css } from "styled-components";

import {
  poppins_body_sm_medium,
  poppins_caption_md_medium,
} from "@shared/font/poppins";
import {
  ptSerif_body_sm_regular,
  ptSerif_caption_md_regular,
  ptSerif_caption_md_bold,
} from "@shared/font/pt-serif";

export type RoleTagVariant =
  | "searchPoppins"
  | "searchPtSerif"
  | "detailPtSerif"
  | "detailMAPtSerif"
  | "detailPoppins"
  | "detailPoppinsBorder"
  | "resultMetricsTopDeals";

export const Tag = styled.span<{
  $variant: RoleTagVariant;
  $isPrimary?: boolean;
}>`
  display: inline;
  word-break: break-all;
  letter-spacing: -0.05px;
  background: var(--Color-Common-Bg-Secondary, #f0f2f4);
  border: 1px solid #f0f2f4;
  color: var(--Color-Common-Text-Primary, #2a2f37);
  ${({ $isPrimary }) =>
    $isPrimary &&
    css`
      font-weight: 700 !important;
      border: 1px solid var(--Color-Common-Border-Secondary, #b1b8c4);
    `}

  ${({ $variant }) => {
    switch ($variant) {
      case "detailPtSerif":
        return css`
          padding: var(--Spacing-2, 0.4rem) var(--Spacing-6, 0.8rem);
          ${ptSerif_body_sm_regular}
          border-radius: var(--Border-Radius-4, 0.4rem);
        `;
      case "detailMAPtSerif":
        return css`
          padding: var(--Spacing-2, 0.2rem) var(--Spacing-6, 0.8rem);
          ${ptSerif_body_sm_regular}
          border-radius: var(--Border-Radius-4, 0.4rem);
        `;
      case "detailPoppins":
        return css`
          padding: var(--Spacing-2, 0.4rem) var(--Spacing-6, 1.2rem);
          ${poppins_body_sm_medium}
          border-radius: var(--Border-Radius-circle, 99999.9rem);
        `;
      case "detailPoppinsBorder":
        return css`
          padding: var(--Spacing-2, 0.4rem) var(--Spacing-6, 1.2rem);
          ${poppins_body_sm_medium}
          border-radius: var(--Border-Radius-circle, 99999.9rem);
          border: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
        `;
      case "searchPtSerif":
        return css`
          padding: var(--Spacing-2, 0.2rem) var(--Spacing-6, 0.6rem);
          ${ptSerif_caption_md_regular}
          border-radius: var(--Border-Radius-2, 0.2rem);
        `;
      case "resultMetricsTopDeals":
        return css`
          padding: var(--Spacing-2, 0.2rem) var(--Spacing-6, 0.6rem);
          ${ptSerif_caption_md_bold}
          border-radius: var(--Border-Radius-2, 0.4rem);
        `;
      case "searchPoppins":
      default:
        return css`
          padding: var(--Spacing-2, 0.2rem) var(--Spacing-6, 0.6rem);
          ${poppins_caption_md_medium}
          border-radius: var(--Border-Radius-circle, 99999.9rem);
        `;
    }
  }}
`;
